import CustomDatatableWithSearch from 'libs/datatables/custom_datatable_with_search'

const { $ } = window

export default function () {
  const options = { disableCompactMode: true, stateSave: false }
  new CustomDatatableWithSearch($('#index_table'), $('#search'), options)
}
